import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-update-estimated-performance-modal',
  templateUrl: './update-estimated-performance-modal.component.pug',
  styleUrls: ['./update-estimated-performance-modal.component.scss']
})
export class UpdateEstimatedPerformanceModalComponent implements OnInit {

  @Input() data: any;

  estimateOption: 'portfolio' | 'new' = 'portfolio';
  newPercentageValue: number = null;

  ngOnInit() {
    this.estimateOption = this.data.portfolioAverageValue != null ? 'portfolio' : 'new';
  }

  confirm() {
    const percentage = this.estimateOption === 'portfolio' ? this.data.portfolioAverageValue : this.newPercentageValue;
    this.data.confirmFunction(percentage);
    this.data.close();
  }

  close() {
    this.data.close();
  }
}
